import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=5f42600e&scoped=true"
import script from "./DropdownItem.vue?vue&type=script&lang=ts"
export * from "./DropdownItem.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./DropdownItem.vue?vue&type=style&index=0&id=5f42600e&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5f42600e",
  null
  ,true
)

export default component.exports